export default __webpack_public_path__ + "static/media/logoautocore.03175932.png";